import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { ToolbarButton } from "../toolbar-button";
import { CopyIcon, ExternalLinkIcon, Link2Off } from "lucide-react";

interface LinkPopoverBlockProps {
  url: string;
  onClear: () => void;
  onEdit: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const LinkPopoverBlock: React.FC<LinkPopoverBlockProps> = ({
  url,
  onClear,
  onEdit,
}) => {
  const [copyTitle, setCopyTitle] = React.useState<string>("Copy");

  const handleCopy = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setCopyTitle("Copied!");
          setTimeout(() => setCopyTitle("Copy"), 1000);
        })
        .catch(console.error);
    },
    [url]
  );

  const handleOpenLink = React.useCallback(() => {
    window.open(url, "_blank", "noopener,noreferrer");
  }, [url]);

  return (
    <div className="flex items-center gap-0.5 rounded-lg border bg-popover p-1 shadow-md">
      <div className="inline-flex items-center gap-0.5">
        <ToolbarButton
          tooltip="Edit link"
          onClick={onEdit}
          className="w-auto px-2 rounded-sm"
        >
          Edit link
        </ToolbarButton>
        <Separator orientation="vertical" className="mx-0.5 h-4" />
        <ToolbarButton
          tooltip="Open link in a new tab"
          onClick={handleOpenLink}
          className="rounded-sm"
        >
          <ExternalLinkIcon className="size-4" />
        </ToolbarButton>
        <ToolbarButton tooltip="Clear link" onClick={onClear} className="rounded-sm">
          <Link2Off className="size-4" />
        </ToolbarButton>
        <ToolbarButton
          tooltip={copyTitle}
          onClick={handleCopy}
          className="rounded-sm"
          tooltipOptions={{
            onPointerDownOutside: (e) => {
              if (e.target === e.currentTarget) e.preventDefault();
            },
          }}
        >
          <CopyIcon className="size-4" />
        </ToolbarButton>
      </div>
    </div>
  );
};
